var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-pdv btn-pdv-blue",attrs:{"type":"button","href":"javascript: void(0);","disabled":_vm.busy || _vm.disabled},on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.busy)?[_c('b-spinner',{attrs:{"small":""}})]:[_vm._v(" "+_vm._s(`${_vm.getI18n('COMMON.update')} ${_vm.title}`)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }